import { LevelSpec } from '../game/LevelSpec';
import { Fridge } from '../game/objects/Fridge';
import { Grill } from '../game/objects/Grill';
import { Direction, dirRotation } from '../game/Direction';
import { Bench } from '../game/objects/Bench';
import { ServingSpot } from '../game/objects/ServingSpot';
import { Skewer } from '../game/objects/Skewer';
import { CookState } from '../game/components/Cookable';
export default new LevelSpec({
    title: 'Time to Cook!',
    goal: 'Cook a <keyword type="food">skewer</keyword> for <b>5 ticks</b> and take it to the <keyword type="conveyor">conveyor belt</keyword> to serve it.',
    testGoal: (world) => {
        const skewer = world.served.find(obj => obj instanceof Skewer);
        switch (skewer && skewer.cookState) {
            case CookState.Raw:
                return { win: false, reason: 'The skewer is still raw.' };
            case CookState.Cooked:
                return { win: true };
            case CookState.Burnt:
                return { win: false, reason: 'The skewer is burnt.' };
        }
    },
    helpText: `
		<p>
			Let's get cooking! We're going to make some delicious <keyword type="food">skewers</keyword>.
		</p>

		<p>
			You already know how to <code>grab()</code> a <keyword type="food">skewer</keyword> from the
			<keyword>fridge</keyword>, and how to <code>drop()</code> it onto the grill. But let's learn
			a few new <b>methods</b> you can use to command your robot.
		</p>

		<h3>walk_to</h3>

		<p>
			<code>walk_to()</code> lets you move your Robot to a specific location on the map. It takes
			three parameters:
		</p>
		
		<ul>
			<li>
				<code>x</code> and <code>y</code>: The location on the map to move to, specified as x and y
				coordinates. To figure out the x and y coordinates of a location, hover your mouse over any
				location in the kitchen. The coordinates will be displayed in the top-left corner of the game
				screen.
			</li>
			<li>
				<code>direction</code>: The direction to face when you arrive at the location. This can be
				any of the four cardinal directions: <code>NORTH</code>, <code>EAST</code>, <code>SOUTH</code>,
				or <code>WEST</code>.
			</li>
		</ul>

		<p>
			When a method takes multiple parameters, separate them with a comma. For example:
		</p>

		<code-block>
			# Walk to the fridge.
			red.walk_to( x = 2, y = 1, direction = NORTH )

			# Walk to the grill.
			# Don't forget: you can specify parameters by name or by position.
			red.walk_to( 3, 2, EAST )
		</code-block>

		<h3>wait</h3>

		<p>
			Once your <keyword type="food">skewer</keyword> is on the grill, you will need to
			<code>wait()</code> for it to cook. The <code>wait()</code> method takes one parameter;
			<code>time</code>, which specifies how many ticks you want to wait. For example:
		</p>

		<code-block>
			# Wait for the skewer to cook.
			red.wait( time = 5 )
		</code-block>
	`,
    lockedLines: 3,
    defaultCode: `
		from kitchen import *

		red = robots.get( 'red' )

		# Get a skewer from the fridge
		red.walk_to( 2, 1, direction = NORTH )
		red.grab()

		# Put the skewer on the grill.

		# Wait for 5 ticks.

		# Take the skewer to the conveyor.
	`,
    layout: [
        'dbfbb',
        '...rn',
        '....g',
        '....n',
    ],
    spawners: {
        d: (map, pos) => [new ServingSpot(map, pos, Direction.South)],
        b: (map, pos) => [new Bench(map, pos, Direction.South)],
        n: (map, pos) => [new Bench(map, pos, Direction.West)],
        f: (map, pos) => [new Fridge(map, pos, Skewer)],
        g: (map, pos) => {
            const g = new Grill(map, pos);
            g.model.quaternion.copy(dirRotation(Direction.West));
            return [g];
        },
    }
});
